export const COMPLETED_TRAINING_WORKSHOPS = [
  { code: 'research-methodology', name: 'Workshop on Research Methodology' },
  { code: 'ict', name: 'Information and Communication Technology (ICT)' },
  { code: 'communication-skills', name: 'Workshop on Communication Skills' },
  {
    code: 'eoc-and-neonatal-care',
    name: 'Workshop on Emergency Obstetrics Care (EOC) and Neonatal Care (NC)',
  },
  { code: 'basic-surgical-skills', name: 'Basic Surgical Skills' },
  { code: 'basic-ophthalmological-skills', name: 'Basic Ophthalmological Skills' },
  { code: 'temporal-bone-dissection', name: 'Temporal Bone Dissection' },
  { code: 'atls', name: 'Advanced Trauma Life Support (ATLS)' },
  { code: 'bls', name: 'Basic Life Support (BLS)' },
  { code: 'acls', name: 'Advanced Cardiovascular Life Support (ACLS)' },
  { code: 'laparoscopic-skills', name: 'Laparoscopic Skills Course' },
  { code: 'epls', name: 'Essential Paediatrics Life Support (EPLS)' },
  { code: 'emsb', name: 'Emergency Management of Severe Burns (EMSB)' },
] as const;

export type CompletedTrainingWorkshopCode =
  typeof COMPLETED_TRAINING_WORKSHOPS[number]['code'];

